"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OKIcon = require("./OKIcon.js");

var _OKIcon2 = _interopRequireDefault(_OKIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _OKIcon2.default;